import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import OurProducts from "./pages/OurProducts";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact";
import FloatingContactIcons from "./components/FloatingContactIcons";
import AdminEditor from "./pages/adminpages/AdminPanel";
import CategoryProducts from "./pages/CategoryProducts";
import HeadMetaUpdater from "./components/HeadMetaUpdater"; // Import HeadMetaUpdater
import ScrollToTop from "./components/ScrollToTop"; // Import the ScrollToTop component

const App = () => {
  return (
    <Router>
      {/* ScrollToTop ensures that every new route loads at the top */}
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gray-100">
        {/* HeadMetaUpdater updates meta tags from Firebase */}
        <HeadMetaUpdater />

        <Header />

        <div className="flex-grow flex items-center justify-center p-4">
          <FloatingContactIcons />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/product-details" element={<ProductDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminEditor />} />
            <Route path="/category/:name" element={<CategoryProducts />} />
            <Route path="/OurProducts" element={<OurProducts />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
